module.exports = __webpack_public_path__ + "software-consulting-design.2YCARove.svg";